import { AppBar, Tabs, Tab, makeStyles } from '@material-ui/core';
import * as React from 'react';
import { ReservationSettingsValuesTab } from './ReservationSettingsValuesTab';
import { OpeningHoursTab } from './OpeningHoursTab';
import { SpecialDaysTab } from './SpecialDaysTab';
import { ExperiencesTab } from './ExperiencesTab';

export enum ReservationsSettingsTabList {
  VALUES = 'values',
  OPENING_HOURS = 'opening-hours',
  SPECIAL_DAYS = 'special-days',
  EXPERIENCES = 'experiences',
}

const useStyles = makeStyles((theme) => ({
  appBar: { marginBottom: theme.spacing(2) },
}));

/**
 * Local-state tab switcher. Uses MUI Tabs directly, NOT the AppTabs
 * component, because AppTabs reads the URL hash and we are nested
 * inside the parent Reservations AppTabs which also reads the hash.
 * Two AppTabs at the same time fight for the hash and the outer one
 * loses (falls back to its default tab) whenever the inner one is
 * clicked. Plain useState here avoids the conflict entirely.
 */
export const ReservationsSettingsTab: React.FC = () => {
  const classes = useStyles();
  const [active, setActive] = React.useState<ReservationsSettingsTabList>(
    ReservationsSettingsTabList.VALUES,
  );

  return (
    <React.Fragment>
      <AppBar position="static" color="default" elevation={1} className={classes.appBar}>
        <Tabs
          value={active}
          onChange={(_, v) => setActive(v as ReservationsSettingsTabList)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          <Tab label="General" value={ReservationsSettingsTabList.VALUES} />
          <Tab label="Opening Hours" value={ReservationsSettingsTabList.OPENING_HOURS} />
          <Tab label="Special Days" value={ReservationsSettingsTabList.SPECIAL_DAYS} />
          <Tab label="Experiences" value={ReservationsSettingsTabList.EXPERIENCES} />
        </Tabs>
      </AppBar>
      {active === ReservationsSettingsTabList.VALUES && <ReservationSettingsValuesTab />}
      {active === ReservationsSettingsTabList.OPENING_HOURS && <OpeningHoursTab />}
      {active === ReservationsSettingsTabList.SPECIAL_DAYS && <SpecialDaysTab />}
      {active === ReservationsSettingsTabList.EXPERIENCES && <ExperiencesTab />}
    </React.Fragment>
  );
};
